/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBusinessAddress_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_physicalAddress_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly street: string | null, readonly streetAdditional: string | null, readonly city: string | null, readonly state: string | null, readonly countryCode: string | null, readonly postalCode: string | null };

export type GetBusinessAddress_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_mailingAddress_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly street: string | null, readonly streetAdditional: string | null, readonly city: string | null, readonly state: string | null, readonly countryCode: string | null, readonly postalCode: string | null };

export type GetBusinessAddress_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly mailingPhysicalAddressesEqual: boolean | null, readonly physicalAddress: GetBusinessAddress_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_physicalAddress_CreditApplicationAddress | null, readonly mailingAddress: GetBusinessAddress_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_mailingAddress_CreditApplicationAddress | null };

export type GetBusinessAddress_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly businessInfo: GetBusinessAddress_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null };

export type GetBusinessAddress_Query = { readonly __typename: 'Query', readonly creditApplication: GetBusinessAddress_creditApplication_CreditApplication | null };


export type GetBusinessAddressVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetBusinessAddress = GetBusinessAddress_Query;


export const GetBusinessAddressDocument = gql`
    query GetBusinessAddress($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    fetchedAt
    businessInfo {
      mailingPhysicalAddressesEqual
      physicalAddress {
        street
        streetAdditional
        city
        state
        countryCode
        postalCode
      }
      mailingAddress {
        street
        streetAdditional
        city
        state
        countryCode
        postalCode
      }
    }
  }
}
    `;

/**
 * __useGetBusinessAddress__
 *
 * To run a query within a React component, call `useGetBusinessAddress` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAddress` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAddress({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetBusinessAddress(baseOptions: Apollo.QueryHookOptions<GetBusinessAddress, GetBusinessAddressVariables> & ({ variables: GetBusinessAddressVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessAddress, GetBusinessAddressVariables>(GetBusinessAddressDocument, options);
      }
export function useGetBusinessAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessAddress, GetBusinessAddressVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessAddress, GetBusinessAddressVariables>(GetBusinessAddressDocument, options);
        }
export function useGetBusinessAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessAddress, GetBusinessAddressVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessAddress, GetBusinessAddressVariables>(GetBusinessAddressDocument, options);
        }
export type GetBusinessAddressHookResult = ReturnType<typeof useGetBusinessAddress>;
export type GetBusinessAddressLazyQueryHookResult = ReturnType<typeof useGetBusinessAddressLazyQuery>;
export type GetBusinessAddressSuspenseQueryHookResult = ReturnType<typeof useGetBusinessAddressSuspenseQuery>;
export type GetBusinessAddressQueryResult = Apollo.QueryResult<GetBusinessAddress, GetBusinessAddressVariables>;